module.exports = __webpack_public_path__ + "static/media/temperature-three-quarter.bfeac517.svg";